/**
 * @generated SignedSource<<68132f2e0e3fc8e5ef55595efa525094>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingDownloadMobileAppFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingDownloadMobileAppContentFragment" | "useMemberOnboardingFormStoreFragment">;
  readonly " $fragmentType": "MemberOnboardingDownloadMobileAppFragment";
};
export type MemberOnboardingDownloadMobileAppFragment$key = {
  readonly " $data"?: MemberOnboardingDownloadMobileAppFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingDownloadMobileAppFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingDownloadMobileAppFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMemberOnboardingFormStoreFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberOnboardingDownloadMobileAppContentFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "cc124f1652e52b378eff80a4ed9fcd0d";

export default node;
